<div class="advanced-filter-container">
  @if (showTrigger) {
    <div class="d-inline-flex align-items-center">
      <button type="button" class="filter-icon-btn" [class.has-active]="activeFiltersCount() > 0"
        (click)="toggleOpen()" title="Filtros avanzados">
        <i class="fas fa-filter"></i>
        @if(activeFiltersCount() > 0) {
          <span class="filter-count-badge">{{ activeFiltersCount() }}</span>
        }
      </button>
    </div>
  }

  @if (appSettings.isMobile()) {
    <app-bottom-sheet [open]="isOpen()" title="Filtros avanzados" (closed)="close()">
      <div class="d-flex align-items-center gap-2 px-3 pt-2 pb-2">
        <button type="button" class="btn btn-outline-success btn-sm" (click)="addRule()" [disabled]="!hasAvailableFields()">
          <i class="fas fa-plus me-1"></i>Agregar
        </button>
        @if (rules().length > 0) {
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearRules()">
            <i class="fas fa-times me-1"></i>Limpiar
          </button>
        }
        @if (activeFiltersCount() > 0) {
          <span class="small text-success fw-bold ms-auto">{{ activeFiltersCount() }} activo(s)</span>
        }
      </div>

      <div class="filter-rules-list d-flex flex-column gap-3 px-3 pb-3">
        @for (rule of rules(); track rule.id) {
          <div class="filter-rule-mobile">
            <app-sheet-select
              [items]="rule.availableFields ?? fields"
              bindLabel="label"
              bindValue="key"
              title="Campo"
              placeholder="Seleccionar campo"
              [(ngModel)]="rule.field"
              (ngModelChange)="onRuleChange()">
            </app-sheet-select>
            <div class="d-flex gap-2 mt-2">
              <input type="text" class="form-control" [(ngModel)]="rule.value"
                (input)="onRuleChange()" placeholder="Valor a buscar...">
              <button type="button" class="btn btn-outline-danger btn-sm border-0" (click)="removeRule(rule.id)" title="Eliminar este filtro">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </div>
        }
        @if (rules().length === 0) {
          <div class="bottom-sheet-empty">No hay filtros. Tocá Agregar.</div>
        }
      </div>
    </app-bottom-sheet>
  } @else if (isOpen()) {
    <div class="advanced-filter-floating-panel p-3 rounded shadow-lg">
      <div class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
        <div class="d-flex align-items-center gap-2">
          <i class="fas fa-filter text-primary me-1"></i>
          <span class="small fw-bold text-uppercase">Filtros Avanzados</span>
          <button type="button" class="btn btn-outline-success btn-sm ms-2" (click)="addRule()" [disabled]="!hasAvailableFields()">
            <i class="fas fa-plus me-1"></i> Agregar
          </button>
          @if(rules().length > 0) {
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearRules()">
              <i class="fas fa-times me-1"></i> Limpiar
            </button>
          }
        </div>
        <div class="d-flex align-items-center gap-2">
          @if(activeFiltersCount() > 0) {
            <span class="small text-success fw-bold"><i class="fas fa-check-circle me-1"></i>{{ activeFiltersCount() }} activo(s)</span>
          }
          <button type="button" class="btn btn-sm btn-link text-muted p-0 ms-2 text-decoration-none" (click)="close()" title="Cerrar filtros">
            <i class="fas fa-times fa-lg"></i>
          </button>
        </div>
      </div>

      <div class="filter-rules-list d-flex flex-column gap-2">
        @for(rule of rules(); track rule.id) {
          <div class="row g-2 align-items-center">
            <div class="col-12 col-md-5">
              <app-sheet-select [items]="rule.availableFields ?? fields" bindLabel="label" bindValue="key"
                [(ngModel)]="rule.field" (ngModelChange)="onRuleChange()"
                [clearable]="false" placeholder="Seleccionar Campo">
              </app-sheet-select>
            </div>
            <div class="col-10 col-md-6">
              <input type="text" class="form-control form-control" [(ngModel)]="rule.value"
                (input)="onRuleChange()" placeholder="Ingrese valor a buscar...">
            </div>
            <div class="col-2 col-md-1 text-end">
              <button type="button" class="btn btn-outline-danger btn-sm border-0" (click)="removeRule(rule.id)" title="Eliminar este filtro">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </div>
        }
        @if(rules().length === 0) {
          <div class="text-center text-muted py-2 small">
            No hay filtros configurados. Haga clic en <strong>+ Agregar</strong>.
          </div>
        }
      </div>
    </div>
  }
</div>
